import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { TranslationKeys } from "translations";
import { FormEnums } from "models/enums";
import { TimeLogsViewProps } from "models/propTypes/timeReportingProjectPropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TimeReportingProjectFormTypes } from "models/formTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
import TimeLogsList from "./timeLogsList";
//#endregion

const TimeLogsForm: ForwardRefRenderFunction<FormHandles, TimeLogsViewProps> = (props, ref) => {
  const { onRowsChange, hiddenColumns, allowCheckBoxSelection } = props;
  return (
    <GenericForm<TimeReportingProjectFormTypes.ProjectData>
      formRef={ref}
      {...props}
      fields={{
        rows: {
          controlLabel: " ",
          label: TranslationKeys.Common.Employee,
          type: FormEnums.FormFieldType.CUSTOM,
          customField: (
            <TimeLogsList
              {...props}
              onChange={() => {}}
              hiddenColumns={hiddenColumns}
              allowCheckBoxSelection={allowCheckBoxSelection}
            ></TimeLogsList>
          ),
          onChangeHandler: onRowsChange,
        },
      }}
      hideSuccess
      formGridLayout={{ message: false }}
    />
  );
};

export default forwardRef(TimeLogsForm);
